(function() {
  $(document).on('click', '.preview-wrapper .add_to_cart', function(){
    $('.btn-add-to-cart').click();
    $(this).html('<span>Adding to Cart...</span>');
    $(this).prop('disabled', true);
    $(this).css({ opacity: 0.5, cursor: 'not-allowed' });
  });

  $(document).on('changeVariant', function(e) {
    window.publish('variant:change', e.detail.variant);
  });

  $(document).on('ready', function (e) {
    if (document.querySelector('upsell-products')) {
      document.querySelector('.add-to-cart-group').before(document.querySelector('upsell-products'));
    }
  });
})();